import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AdminPage from './adminPages/Admin/Admin.page';
import ChatPage from './pages/Chat/Chat.page';
import Signin from './pages/User/SignIn/SignIn.page';
import Signup from './pages/User/SignUp/SignUp.page';
import PrivateRoute from './helpers/protectedRoutes';
import UploadPage from './adminPages/Upload/Upload.page';
import HomePage from './pages/Home/Home.page';
import ChatHistorySearch from './ui/components/chatHistorySearch/chatHistorySearch';
// import Test from './pages/Test/Test.page';
import TranscriptsPage from './adminPages/Transcripts/Transcripts.page';
import BulkUploadPage from './adminPages/BulkUpload/BulkUpload.page';
import Test from './pages/Test/Test.page';
import AddNewEntityPage from './adminPages/AddNewEntity/AddNewEntity.page';
import AddNewPackagePage from './adminPages/AddNewPackage/AddNewPackage.page';
import LetterPage from './adminPages/LetterPage/Letter.page';
import TempPage from './adminPages/TempPage/Temp.page';
import ResearchPage from './pages/ResearchPage/ResearchPage';
import ForgotPassword from './pages/User/ForgotPassword/ForgotPassword.page';
import ResetPassword from './pages/User/ResetPassword/ResetPassword.page';
import ChangePassword from './pages/User/ChangePassword/ChangePassword.page';
import ScienceSummariesPage from './pages/ScienceSummaries/ScienceSummaries.page';

//TODO move ChatHistorySearch from being a route to being part of the side bar expansion

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            {' '}
            <AdminPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/upload"
        element={
          <PrivateRoute>
            {' '}
            <UploadPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/transcripts"
        element={
          <PrivateRoute>
            {' '}
            <TranscriptsPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/upload/bulk"
        element={
          <PrivateRoute>
            {' '}
            <BulkUploadPage />{' '}
          </PrivateRoute>
        }
      />
      {/* TODO THESE 2 ARE TEMPORARY, need to be replaced later */}
      <Route
        path="/admin/entity/add"
        element={
          <PrivateRoute>
            {' '}
            <AddNewEntityPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/package/add"
        element={
          <PrivateRoute>
            {' '}
            <AddNewPackagePage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/letter"
        element={
          <PrivateRoute>
            {' '}
            <LetterPage />{' '}
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/citation"
        element={
          <PrivateRoute>
            {' '}
            <TempPage />{' '}
          </PrivateRoute>
        }
      />
      <Route path="/signin" element={<Signin />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/change-password"
        element={
          <PrivateRoute>
            <ChangePassword />
          </PrivateRoute>
        }
      />
      <Route
        path="/science-summaries"
        element={
          <PrivateRoute>
            <ScienceSummariesPage />
          </PrivateRoute>
        }
      />

      {/* <Route path="/chat/history/search" element={<ChatHistorySearch />} />
      {/* TODO Make sure to comment out test whenever pushing to live, or delete it, however */}
      <Route path="/test" element={<Test />} />
      <Route path="/research" element={<ResearchPage />} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
